import React, {useEffect} from "react";
import { FeedbackContainer, ScreenResponsive } from "../../../components";
import {
	ButtonLayout,
	ButtonPrimary,
	Grid,
	GridItem,
	IconWarningLight,
	Text3,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";
import { strings } from "../../../localization";
import { observer, useLocalObservable } from "mobx-react-lite";
import { PostBalanceInquiryRequestFetchStore } from "../../../stores";
import { useGlobalStore } from "../../../contexts/globalStoreContext";
import { useAnalytics } from "../../../hooks/useAnalytics";
import { useNavigateCustom } from "../../../hooks";

export const CaixaError: React.FC = observer(() => {
	const errorInfo = strings.components.connectionFeedback.errors;

	const { addAnalyticEvent, updatePageView } = useAnalytics();
	const { isDesktopOrBigger } = useScreenSize();
	const { authenticationStore } = useGlobalStore();
	const navigation = useNavigateCustom();
	const store = useLocalObservable(
		() => new PostBalanceInquiryRequestFetchStore(
			authenticationStore,
			() => navigation("/connect-fgts-balance"),
		),
	);

	const handleOnPress = async (): Promise<void> => {
		store.fetchShelf.fetch();

		addAnalyticEvent({
			component: "body",
			action: "click.button",
			description: errorInfo.caixaError.buttons.primaryButton,
			step: "fgts:sistema-indisponivel",
			value: "",
		}, {applySanitize: true});
	};

	useEffect(()=>{
		addAnalyticEvent({
			component: "body",
			action: "view-error",
			description: "sistema-indisponivel",
			step: "fgts:sistema-indisponivel",
			value: "",
			event: "non_interaction",
		}, {applySanitize: true});

		updatePageView({
			name: "Vivo Money FGTS Sistema Indisponível",
			pagePath: "/fgts/sistema-indisponivel",
		});
	},[]);

	return (
		<ScreenResponsive>
			<Grid justifyContent="center">
				<GridItem>
					<FeedbackContainer
						icon={<IconWarningLight size={64} color={skinVars.colors.controlError} />}
						title={errorInfo.caixaError.title}
						description={errorInfo.caixaError.text}
					>
						<ButtonLayout align={isDesktopOrBigger ? "left" : "center"}>
							<ButtonPrimary
								onPress={handleOnPress}
								showSpinner={store.fetchShelf.loader.isLoading}
								disabled={store.fetchShelf.loader.isLoading}
								style={{ width: isDesktopOrBigger ? "auto" : "100%" }}
							>
								<Text3 medium color={skinVars.colors.textButtonPrimary}>
									{errorInfo.caixaError.buttons.primaryButton}
								</Text3>
							</ButtonPrimary>
						</ButtonLayout>
					</FeedbackContainer>
				</GridItem>
			</Grid>
		</ScreenResponsive>
	);
});

export default CaixaError;
